<div
	[ngClass]="{
		'opacity-100 visible': open,
		'opacity-0 invisible': !open
	}"
	class="relative z-[9999] transition-all duration-500 ease-in-out"
	aria-labelledby="slide-over-title"
	role="dialog"
	aria-modal="true"
>
	<!-- Backdrop Overlay -->
	<div
		(click)="closeHistory()"
		[ngClass]="{
			'opacity-100': open,
			'opacity-0': !open
		}"
		class="fixed inset-0 bg-accent/40 backdrop-blur-sm transition-opacity duration-500 ease-in-out cursor-pointer"
		aria-hidden="true"
	></div>

	<div class="fixed inset-0 overflow-hidden pointer-events-none">
		<div class="absolute inset-0 overflow-hidden">
			<div
				class="fixed inset-y-0 right-0 flex max-w-full"
			>
				<!-- Side Panel -->
				<div
					[ngClass]="{
						'translate-x-0': open,
						'translate-x-full': !open
					}"
					class="pointer-events-auto w-screen sm:max-w-md transform transition-transform duration-500 cubic-bezier(0.4, 0, 0.2, 1) shadow-[0_20px_40px_-10px_rgba(31,41,55,0.15)]"
				>
					<div
						class="flex h-full flex-col overflow-hidden bg-other shadow-xl border-s border-gray-100"
					>
						<!-- Header -->
						<div class="flex-none p-6 bg-white border-b border-gray-100">
							<div class="flex items-center justify-between">
								<div class="flex flex-col">
									<div class="flex items-center space-x-2 mb-1">
										<span class="w-4 h-[2px] bg-primary rounded-full"></span>
										<span class="text-primary font-bold tracking-[0.2em] uppercase text-[10px]">Trazabilidad</span>
									</div>
									<h2
										class="text-xl font-extrabold text-accent font-['Lexend'] tracking-tight"
										id="slide-over-title"
									>
										Historial de Cambios
									</h2>
								</div>
								<div class="ml-3 flex h-7 items-center">
									<button
										(click)="closeHistory()"
										type="button"
										class="group relative -m-2 p-2 text-gray-400 hover:text-primary transition-colors duration-200 focus:outline-none"
									>
										<span class="sr-only">Cerrar panel</span>
										<svg
											class="h-6 w-6"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											aria-hidden="true"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6 18 18 6M6 6l12 12"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>

						<!-- Content Area -->
						<div
							class="flex-1 px-6 py-8 overflow-y-auto no-scrollbar bg-other"
						>
							<ol
								class="relative border-s border-gray-200 ml-4"
							>
								@for (history of freight?.histories; track history) {
									<li class="mb-12 ms-8 last:mb-0">
										<span
											class="absolute flex items-center justify-center w-9 h-9 bg-secondary rounded-full -start-[1.125rem] ring-4 ring-other shadow-sm shadow-primary/5"
										>
											<svg
												class="w-4 h-4 text-primary"
												aria-hidden="true"
												xmlns="http://www.w3.org/2000/svg"
												fill="currentColor"
												viewBox="0 0 20 20"
											>
												<path
													d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
												/>
											</svg>
										</span>
										<div class="flex flex-col gap-2">
											<div class="flex items-start justify-between gap-4">
												<h3
													class="text-base font-bold text-accent leading-tight font-['Poppins']"
												>
													{{ history.title }}
												</h3>
												@if (history.latest) {
													<span
														class="flex-none bg-primary-50 text-primary-700 text-[9px] font-black uppercase tracking-widest px-2.5 py-1 rounded-md"
													>
														Reciente
													</span>
												}
											</div>
											<time
												class="block text-[11px] font-bold text-gray-400 uppercase tracking-widest font-['Source_Sans_3']"
											>
												{{
													history.creationDate
														| localTime
														| date: 'dd MMM, yyyy · HH:mm'
												}}
											</time>
											<div
												[innerHTML]="getSanitizedHtml(history.content)"
												class="text-sm font-normal text-gray-600 leading-relaxed font-['Poppins'] bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_10px_20px_-5px_rgba(31,41,55,0.03)]"
											></div>
										</div>
									</li>
								}
							</ol>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


